import consumer from "./consumer"
let current_user
let mode_user
consumer.subscriptions.create("ContractsChannel", {
    connected() {
        // Called when the subscription is ready for use on the server
        current_user = $('#current_user_id').val();
        mode_user = $('#current_user_mode').val();
    },

    disconnected() {
        // Called when the subscription has been terminated by the server
    },

    received(data) {
        let mode = mode_user === 'true'
        if ( (mode === data.content.user_mode && data.content.refer_to === parseInt(current_user)) ||
            (mode === data.content.user_mode && data.content.providers.includes(parseInt(current_user)))) {
            $("#noty").removeClass("d-block").addClass("d-none");
            $("#live-noty").removeClass("d-none").addClass("d-block");
            let countData = $('#nav-noti-count').text();
            if (countData === '' || countData === 'undefined'){
                countData = 0;
            }
            $('#nav-noti-count').text(parseInt(countData) + 1);
        }
    }
});
